import * as React from "react";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import axios from "../../libs/axios";

export default function AlertDialog({
  row,
  setSnackalert,
  loadData,
  name,
  setReAssessment,
  setCallingBackend,
  setRows,
}) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const onReAssessment = async (row) => {
    try {
      await axios.post("/assesment/reassesst", { row });
      await axios.put(`/assesment/reassessment/${row._id}`);
      setSnackalert(true);
      setTimeout(() => setSnackalert(false), 5000);
      setReAssessment(false);
      loadData2(false);
    } catch (error) {}
  };

  const loadData2 = async (reAsses) => {
    try {
      setCallingBackend(true);
      if (reAsses) {
        const { data } = await axios.get("/assesment/list");
        setRows(data);
      } else {
        const { data } = await axios.get("/assesment/reassessment");
        setRows(data);
      }
    } catch (error) {
      console.error("Error loading data", error);
    } finally {
      setCallingBackend(false);
    }
  };

  return (
    <React.Fragment>
      <Tooltip title="Create reassessment">
        <Button
          onClick={() => handleClickOpen()}
          sx={{
            backgroundColor: "#b19777",
            textTransform: "capitalize",
            fontFamily: "serif",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            minWidth: "40px",
            color: "#ffffff",
            ":hover": {
              backgroundColor: "#b19777",
            },
          }}
        >
          <FileCopyIcon />
        </Button>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ fontWeight: 700 }}>
          {"Re-Assessment Confirmation"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ fontSize: "0.9rem" }}
          >
            Are you sure you want to create the Re-Assessment: '{name}'?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            autoFocus
            sx={{
              fontSize: "0.9rem",
              backgroundColor: "#b19777",
              textTransform: "capitalize",
              borderRadius: "8px",
              color: "#ffffff",
              fontFamily: "serif",
              ":hover": { backgroundColor: "#b19777" },
            }}
          >
            Close
          </Button>
          <Button
            onClick={() => onReAssessment(row)}
            sx={{
              fontSize: "0.9rem",
              textTransform: "capitalize",
              backgroundColor: "#22345B",
              color: "#ffffff",
              borderRadius: "8px",
              fontFamily: "serif",
              ":hover": { backgroundColor: "#22345B", color: "#ffffff" },
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
